const MobilWashLogo = ({ className = "h-10" }) => (
  <picture>
    <source srcSet="/mobil-wash-logo.webp" type="image/webp" />
    <img
      src="/mobil-wash-logo.png"
      alt="Mobil Wash"
      width="256"
      height="256"
      decoding="async"
      className={`${className} w-auto object-contain select-none`}
      draggable={false}
      data-testid="mobil-wash-logo"
    />
  </picture>
);

export default MobilWashLogo;
